import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { ReactComponent as RapydLogo } from 'newAssets/rapyd_logo.svg';
import { getRapydPrivacyPolicyLink, isDemoSelector } from 'redux/selectors/global';
import Link from 'components/widgets/Link/Link';
import { footerStyle } from 'styles/global';

const PoweredBy = () => {
  const { t } = useTranslation();

  const isDemo = useSelector(isDemoSelector);
  const rapydPrivacyPolicyLink = useSelector(getRapydPrivacyPolicyLink);

  return (
    <PoweredByWrapper>
      <PoweredByLogoWrapper>
        <span>{t('power_by')}</span>
        <RapydLogo />
      </PoweredByLogoWrapper>
      <Link href={isDemo ? undefined : rapydPrivacyPolicyLink}>
        <span>&nbsp;&nbsp;|&nbsp;&nbsp;{t('policy')}</span>
      </Link>
    </PoweredByWrapper>
  );
};

export default PoweredBy;

const PoweredByWrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;

  span {
    ${footerStyle};
  }

  svg {
    height: 1.2rem;
    width: auto;
  }
`;

const PoweredByLogoWrapper = styled.div`
  display: flex;
  align-items: center;
`;
